import { useEffect, useContext, useState, useRef, forwardRef } from "react";
import {
  Button,
  Divider,
  MultiSelect,
  ScrollArea,
  TextInput,
  Badge,
  Text,
  Select,
  Timeline,
  Group,
  Avatar,
  Checkbox,
} from "@mantine/core";
import InputWithIcon from "./InputWithIcon";
// import Stepper from "../../../components/Stepper/Stepper";
import { BsArrowRight, BsInfoCircleFill } from "react-icons/bs";
import { AddNewsContext } from "../../../utils/context/AddNewsContext";
// import { RichTextEditor } from "@mantine/rte";
import googleFonts from "../../../googleFonts.json";
import { ICategory, ILanguage, IProvider, ISelectedBgImageFromModal } from "../../../utils/types";
import TextSkeleton from "../../../components/TextSkeleton";
import ColorPicker from "../../../components/ColorP/ColorPicker";
import BgImageModal from "./BgImageModal";
import { API_URL, FILE_URL } from "../../../utils/constants";
import { Editor } from "@tinymce/tinymce-react";
import { useTranslation } from "react-i18next";
import { showToast } from "../../../utils/utility";
import "./CreateNewsItemStyle.scss";
import { getAllCategories, getAllLanguage, getAllProvider } from "../../../utils/api/api";
const CreateHtmlFromString = ({ HTMLString }: { HTMLString: string }) => {
  return <div dangerouslySetInnerHTML={{ __html: HTMLString }} />;
};

type Props = {
  onSave: () => void;
  onCancel: () => void;
  checkedCarousel: (e:boolean) => void;
  isCreatingNews?: boolean
};

interface ItemProps {
  image: string;
  label: string;
  description: string;
}

export default function CreateNewsItem({
  onSave,
  onCancel,
  checkedCarousel,
  isCreatingNews
}: Props) {
  const {
    updateAddNewsInfo,
    backgroundUrl,
    newsHeadline,
    textPlacement,
    newsUrl,
    newsTitle,
    language,
    provider,
    categories,
  } = useContext(AddNewsContext);

  const [allCategories, setAllCategories] = useState<ICategory[]>([]);
  const [allProvider, setAllProvider] = useState<IProvider[]>([]);
  const [allLanguage, setAllLanguage] = useState<ILanguage[]>([]);
  const [isFirstLoad, setIsFirstLoad] = useState<boolean>(true);
  const [showBGSelectModal, setShowBgSelectModal] = useState<boolean>(false);
  const [selectedFont, setSelectedFont] = useState<string>("");
  const [headLine, setHeadLine] = useState<string>("");
  const { t, i18n } = useTranslation();

  const editorRef = useRef<any>(null);
  const tinyMCsKey = "z916qx35xowgituqr10rqdchcga4haw8rergzeyht97asnz0";

  const [editedText, setEditedText] = useState<string>("");
  const [isClickedNext, setIsClickedNext] = useState<boolean>(false);
  const [isCarouselChecked,setIsCarouselChecked] =useState<boolean>(false);

  useEffect(() => {
    if (isFirstLoad) {
      setIsFirstLoad(false);
    } else {
      handleFetchCategory();
      handelFetchProvider();
      handleFetchLanguage();
    }
  }, [isFirstLoad]);

  useEffect(() => {
    let updatedValue = headLine;
    if (selectedFont !== "") {
      updatedValue = headLine.replace(
        "<p",
        `<p style="font-family:${selectedFont};"`
      );
    }
    updateAddNewsInfo("headline", updatedValue);
  }, [headLine, selectedFont]);

   useEffect(()=>{
     updateAddNewsInfo('newsType', isCarouselChecked ? 'carousel_news':'news')
      checkedCarousel(isCarouselChecked)
   },[isCarouselChecked])


  const log = () => {
    if (backgroundUrl.length === 0) {
      showToast({
        type: "warning",
        message: "Please select a background to add Headline",
      });
      return;
    }
    if (editorRef.current) {
      let HTMLString = editorRef.current?.getContent();
      setEditedText(HTMLString);
      updateAddNewsInfo("headline", HTMLString);
    }
  };

  const SelectItem = forwardRef<HTMLDivElement, ItemProps>(
    ({ image, label, description, ...others }: ItemProps, ref) => (
      <div ref={ref} {...others}>
        <Group noWrap>
          <Avatar src={`${FILE_URL + image}`} />
          <div>
            <Text size="sm">{label}</Text>
            <Text size="xs" color="dimmed">
              {description}
            </Text>
          </div>
        </Group>
      </div>
    )
  );
  // API function 

  const handleFetchCategory = () => {
    getAllCategories().then(
      (response) => {
        setAllCategories(response.data?.data || []);
      },
      (error) => {
        console.log(error?.response);
      }
    );
  };

  const handelFetchProvider = () => {
    getAllProvider().then(
      (response) => { setAllProvider(response.data?.data || []); },
      (error) => {
        showToast({
          type: "warning",
          title: "Fetch provider failed!",
          message: "could not fetch provider data"
        })
      }
    )
  };

  const handleFetchLanguage = () => {
    getAllLanguage().then(
      (response) => {
        setAllLanguage(response.data?.data || []);
      },
      (error) => {
        showToast({
          type: "warning",
          title: "Fetch Language failed!",
          message: "could not fetch Language data"
        })
      }
    )
  };

  return (
    <div className="h-screen flex flex-col lg:w-[680px] w-full  bg-white -ml-10 border-r">
      <div className="flex justify-between w-full h-16 items-center px-4 py-6 shadow-lg">
        <p className=" font-bold text-xl">{isCarouselChecked ? "Create Carousel News" : t("Create News Item")}</p>
        <Badge variant="light" color="info" className="round-md">
          {t("Pending")}
        </Badge>
      </div>
      {/* <Divider /> */}

      <ScrollArea className="p-4 flex-1 overflow-hidden">
        {/* <div className="p-2 bg-blue-100 border border-orange-200 rounded-lg my-4 flex items-center gap-2 text-sm">
          <BsInfoCircleFill  className="text-orange-500"/>
          Please follow the 3 steps below to create news item.
        </div> */}

        <Timeline bulletSize={20} lineWidth={3}>
          <Timeline.Item title={t("Step 1.")} className="pb-4">
            <h4>{t("Select Background Image")}</h4>
            <p className="opacity-60 mb-6">
              {t("Please select a background image from the repository")}
            </p>
            <Button
              fullWidth
              variant="light"
              size="md"
              className="bg-blue-50 text-blue-600"
              onClick={() => setShowBgSelectModal(true)}
            >
              {t("Select Background Image")}
            </Button>
          </Timeline.Item>

          <Timeline.Item title={t("Step 2.")} className="pb-8">
            <h4>Select Language</h4>
            <Select
              placeholder="English, Hindi, Punjabi"
              radius="md"
              size="md"
              nothingFound="Nothing found"
              value={String(language)}
              data={allLanguage?.map((each) => {
                return { value: String(each?.id), label: each?.language };
              })}
              onChange={(e) => {
                updateAddNewsInfo("language", e || "");
              }}
            />
          </Timeline.Item>

          <Timeline.Item title={t("Step 3.")} className="pb-8">
            <h4>{t("Headline & Placement")}</h4>
            <p className="opacity-60 mb-6">
              {t("Enter news headlines and select placement")}
            </p>
            <>
              <p className="form-label"> {t("News Title")}</p>
              <TextInput
                placeholder={t("Enter news title")}
                radius="md"
                size="md"
                value={newsTitle}
                onChange={(e) => {
                  updateAddNewsInfo("title", e.target.value);
                }}
              />
              <div className="text-xs font-medium bg-orange-50 text-orange-500 rounded-md p-2 mt-2">
                {t(
                  "This is for internal purposes, can be same as the News headline."
                )}
              </div>

              {/* <p className="form-label"> {t("News Headline")}</p> */}
              <Editor
                apiKey={tinyMCsKey}
                onInit={(evt, editor) => (editorRef.current = editor)}
                toolbar="bold italic underline fontfamily fontsize forecolor lineheight alignleft aligncenter alignright alignjustify"
                initialValue="<h2>Enter news <b>description</b> here</h2>"
                init={{
                  height: 350,
                  menubar: false,
                  plugins: [
                    "advlist",
                    "autolink",
                    "lists",
                    "image",
                    "charmap",
                    "preview",
                    "anchor",
                    "searchreplace",
                    "visualblocks",
                    "code",
                    "fullscreen",
                    "insertdatetime",
                    "media",
                    "table",
                    "code",
                    "help",
                    "wordcount",
                  ],
                  // toolbar: 'bold | italic | underline code | fontfamily | fontsize | forecolor',
                  // toolbar: 'undo redo | blocks | ' +
                  //     'bold italic forecolor | alignleft aligncenter ' +
                  //     'alignright alignjustify | bullist numlist outdent indent | ' +
                  //     'removeformat | help',
                  // @import url('https://fonts.googleapis.com/css2?family=Oswald&display=swap');
                  // @import url('https://fonts.googleapis.com/css?family=Warnes&display=swap');
                  content_style:
                    "body { font-family:Helvetica,Arial,sans-serif,Lato; font-size:14px }",
                  font_size_formats: `14pt 18pt 20pt 24pt 30pt 31pt 32pt 33pt 34pt 35pt 36pt 48pt 54pt 64pt`,
                  line_height_formats: `1 1.1 1.2 1.4 1.6 2`,
                  font_family_formats:
                    "Arial=arial,helvetica,sans-serif; Roboto=roboto; Montserrat =montserrat; Poppins=poppins; Lato=lato; Open Sans =open sans; Source Sans Pro=source sans pro; Oswald =oswald;  Raleway =raleway; Inter =inter; Ubuntu =ubuntu; Nunito=nunito; Merriweather=merriweather; Playfair Display=playfair display; Lora=lora; Quicksand=quicksand; Mulish=mulish; PT Serif=pt serif; Noto Serif=noto serif; Josefin Sans=josefin sans ; PT Sans Caption=pt sans caption ; Spectral=spectral; Alata=alata; Orbitron=orbitron; ",
                  font_formats:
                    "Arial Black=arial black,avant garde; Lato =lato; Roboto=roboto;",
                  content_css: "/CreateNewsItemStyle.scss",
                }}
              />
              <Button
                className="bg-blue-600 my-2"
                rightIcon={<BsArrowRight />}
                fullWidth
                onClick={() => log()}
              >
                {t("Add Headline")}
              </Button>

              {/* <p className="form-label">{t("Select Text Placement")}</p>
              <div className="flex mt-2">
                {["Top", "Middle", "Bottom"].map((e) => (
                  <TextSkeleton
                    key={e}
                    position={e}
                    isSelected={textPlacement === e.toLowerCase()}
                    onSelect={() =>
                      updateAddNewsInfo("placement", e.toLowerCase())
                    }
                  />
                ))}
              </div> */}
            </>
          </Timeline.Item>

          <Timeline.Item title={t("Step 4.")} className="pb-8">
            <h4>{t("Other Details")}</h4>
            <p className="opacity-60 mb-6">
              {t("Enter link to the news and select category")}
            </p>

            <>
              <p className="form-label">Select News Provider</p>
              <Select
                searchable
                size="md"
                maxDropdownHeight={400}
                placeholder="Select Provider"
                nothingFound="Nobody here"
                itemComponent={SelectItem}
                data={allProvider?.map((each) => {
                  return {
                    value: String(each?.id),
                    label: each?.name,
                    image: each?.icon?.filename_disk,
                  };
                })}
                value={provider}
                onChange={(e) => {
                  updateAddNewsInfo("provider", e || "");
                }}
              />
              <p className="form-label">{t("Link to News Article")}</p>
              <InputWithIcon
                value={newsUrl}
                onChange={(value) => {
                  updateAddNewsInfo("url", value);
                }}
              />
              <div className="mt-4">
                <p className="form-label">{t("Select Category")}</p>
                <MultiSelect
                  searchable
                  size="md"
                  dropdownPosition="top"
                  nothingFound="Nothing found"
                  placeholder={t("Select")}
                  description={t("You can select multiple categories")}
                  inputWrapperOrder={["input", "description"]}
                  data={allCategories?.map((each) => {
                    return { value: String(each?.id), label: each?.name };
                  })}
                  value={categories}
                  onChange={(e) => {
                    console.log("categories: ", e);
                    updateAddNewsInfo("categories", e.join());
                  }}
                />

                <Checkbox
                  className='mt-3 flex pt-4'
                  checked={isCarouselChecked}
                  onChange={()=>setIsCarouselChecked(!isCarouselChecked)}
                  label="Do you want to make a carousel news"
                />
              </div>
            </>
          </Timeline.Item>
        </Timeline>

        {/* <div className="text-blue-600 font-bold">Step 1. </div>
        <h4>Select Background Image</h4>
        <p className="opacity-60">
          Select background image from the repository
        </p>
        <div className=" mt-4">
          <Button
            fullWidth
            variant="light"
            size="md"
            className="bg-blue-50 text-blue-600"
            onClick={() => setShowBgSelectModal(true)}
          >
            Select Background Image
          </Button>
        </div> */}
      </ScrollArea>

      <div className=" h-16  w-full flex flex-col justify-center">
        <Divider className="mt-0 sticky " />
        <div className="flex p-3 bottom-0 gap-2">
          <Button
            variant="light"
            size="md"
            className="ml-auto"
            onClick={onCancel}
            disabled={isCreatingNews}
          >
            {t("Cancel")}
          </Button>
          <Button
            size="md"
            className="bg-primary"
            loading={isCreatingNews}
            onClick={() => {
              onSave()
              setIsClickedNext(true)
            }}
          >
            {"Save"}
          </Button>
        </div>
      </div>

      <BgImageModal
        isOpen={showBGSelectModal}
        onClose={() => setShowBgSelectModal(false)}
        onSelect={(imgData: ISelectedBgImageFromModal) => {
          console.log("Background modal",imgData)
          updateAddNewsInfo("background", imgData?.imgUrl);
          updateAddNewsInfo("newsImage", imgData?.imgId);
          updateAddNewsInfo("url", imgData?.newsUrlByImage ? imgData?.newsUrlByImage : "");
          setShowBgSelectModal(false);
        }}
      />
    </div>
  );
}
